import { useNavigate } from 'react-router-dom';

import { useGetUserSubscriptionQuery } from 'services';
import { Button, Text } from 'shared/components/ui';
import { useIsFree, useIsPending } from 'features/auth';
import { getDaysLeft } from 'shared/utils/format-timestamp';

import styles from './index.module.scss';

export const SearchUpdate = () => {
	const navigate = useNavigate();
	const isFree = useIsFree();
	const isPending = useIsPending();
	const { data } = useGetUserSubscriptionQuery();

	const handleClick = () => {
		navigate('/registration/plan');
	};

	if (!isPending && !isFree) return null;

	const daysLeft = getDaysLeft(data?.expiration_date);
	const searchesLeft = data?.requests_left;

	const message = isPending
		? `You have ${searchesLeft} searches left on a free trial`
		: `You have ${daysLeft} days left on a free trial`;

	return (
		<section className={styles.update}>
			<Text variant="grotesk/14/bold">✨ {message}</Text>
			<Button type="primary" size="small" onClick={handleClick}>
				Upgrade
			</Button>
		</section>
	);
};
